/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2026 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2026 - Finnish Meteorological Institute (FMI)
 * Copyright 2026 - The Norwegian Meteorological Institute (MET Norway)
 * */

import type { ConfigType } from '@opengeoweb/shared';
import { sessionStorageProvider } from '@opengeoweb/shared';

export interface WarningsFeatures {
  /** public warnings: needs the warnings backend, enabled by default */
  hasPublicWarnings: boolean;
  /** maritime warnings: needs the warnings backend, disabled by default */
  hasMaritimeWarnings: boolean;
  /** warning events: needs the warnings backend, disabled by default */
  hasWarningEvents: boolean;
}

/**
 * Reads which warning types backed by the warnings backend
 * (GW_DRAWINGS_BASE_URL) are enabled. Requests for a disabled type should not
 * be made.
 */
export const getWarningsFeatures = (
  config: ConfigType = sessionStorageProvider.getConfig(),
): WarningsFeatures => {
  const hasWarningsBackend = Boolean(config.GW_DRAWINGS_BASE_URL);
  return {
    hasPublicWarnings:
      hasWarningsBackend && config.GW_FEATURE_PUBLIC_WARNINGS !== false,
    hasMaritimeWarnings:
      hasWarningsBackend && Boolean(config.GW_WARNINGS_MARITIME_WARNINGS),
    hasWarningEvents:
      hasWarningsBackend && Boolean(config.GW_FEATURE_WARNINGS_EVENT),
  };
};
